import React from 'react';

const DashboardHome = () => {
    return (
        <div>
            <h2 className='text-center mt-5 text-success'>Wellcome to your dashboard</h2>
        </div>
    );
};

export default DashboardHome;